/**
 * vue-cesium - https://github.com/zouyaoji/vue-cesium
 * Vue 2.x components for CesiumJS.
 *
 * @package VueCesium
 * @author zouyaoji <370681295@qq.com>
 * @version 2.0.6
 * @license MIT
 * @homepage https://zouyaoji.top/vue-cesium
 * @copyright (c) 2018-2020, zouyaoji <370681295@qq.com>
 */
import _Object$assign from '@babel/runtime-corejs2/core-js/object/assign';
import _regeneratorRuntime from '@babel/runtime-corejs2/regenerator';
import _getIterator from '@babel/runtime-corejs2/core-js/get-iterator';
import cmp from '../virtualCmp';
import { makeColor } from '../../utils/util';

var props = {
  mode: {
    type: Number,
    default: 1
  },
  pointColor: {
    type: String | Object | Array,
    default: 'rgb(255,229,0)'
  },
  pointPixelSize: {
    type: Number,
    default: 8
  }
};
var watch = {
  drawing: function drawing(val) {
    var polylines = this.polylines,
        startNew = this.startNew,
        drawType = this.drawType;
    var polyline = polylines[polylines.length - 1];

    if (!val && polyline && !polyline.positions.length) {
      this.polylines.pop();
    } else if (val) {
      var drawCmpNames = [];

      switch (drawType) {
        case 'pointDrawing':
          drawCmpNames.push('vc-handler-draw-polyline');
          drawCmpNames.push('vc-handler-draw-polygon');
          break;

        case 'polylineDrawing':
          drawCmpNames.push('vc-handler-draw-point');
          drawCmpNames.push('vc-handler-draw-polygon');
          break;

        case 'polygonDrawing':
          drawCmpNames.push('vc-handler-draw-polyline');
          drawCmpNames.push('vc-handler-draw-point');
          break;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(this.$parent.$slots.default || []), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var $node = _step.value;

          if ($node.componentOptions && drawCmpNames.indexOf($node.componentOptions.tag) !== -1) {
            $node.child.drawing = false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      startNew();
    }

    this.viewer.canvas.setAttribute('style', val ? 'cursor: crosshair' : 'cursor: auto');
    var listener = this.$listeners['activeEvt'];
    listener && this.$emit('activeEvt', {
      type: drawType,
      isActive: val
    });
  }
};
var computed = {};
var methods = {
  createCesiumObject: function createCesiumObject() {
    var viewer, handler;
    return _regeneratorRuntime.async(function createCesiumObject$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            viewer = this.viewer;
            handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
            handler.setInputAction(this.LEFT_CLICK, Cesium.ScreenSpaceEventType.LEFT_CLICK);
            handler.setInputAction(this.MOUSE_MOVE, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            handler.setInputAction(this.RIGHT_CLICK, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            this.handler = handler;
            return _context.abrupt("return", this.polylines);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, null, this);
  },
  mount: function mount() {
    return _regeneratorRuntime.async(function mount$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", true);

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    });
  },
  unload: function unload() {
    return _regeneratorRuntime.async(function unload$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", true);

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    });
  },
  LEFT_CLICK: function LEFT_CLICK(movement) {
    if (!this.drawing) {
      return;
    }

    var Cesium = this.Cesium,
        viewer = this.viewer,
        polylines = this.polylines;
    var cartesian = viewer.scene.pickPosition(movement.position);

    if (!Cesium.defined(cartesian)) {
      return;
    }

    var polyline = polylines[polylines.length - 1];
    polyline.positions.push(cartesian);
  },
  MOUSE_MOVE: function MOUSE_MOVE(movement) {
    var Cesium, viewer, polylines, onDrawingEvt, drawType, nIndex, polyline, cartesian, listener;
    return _regeneratorRuntime.async(function MOUSE_MOVE$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (this.drawing) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            Cesium = this.Cesium, viewer = this.viewer, polylines = this.polylines, onDrawingEvt = this.onDrawingEvt, drawType = this.drawType;

            if (polylines.length) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return");

          case 5:
            nIndex = polylines.length - 1;
            polyline = polylines[nIndex];

            if (polyline.positions.length) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return");

          case 9:
            cartesian = viewer.scene.pickPosition(movement.endPosition);

            if (Cesium.defined(cartesian)) {
              _context4.next = 12;
              break;
            }

            return _context4.abrupt("return");

          case 12:
            if (polyline.positions.length >= 2) {
              polyline.positions.pop();
            }

            polyline.positions.push(cartesian);
            listener = this.$listeners['movingEvt'];
            listener && this.$emit('movingEvt', movement.endPosition, drawType);
            onDrawingEvt(polyline, nIndex);

          case 17:
          case "end":
            return _context4.stop();
        }
      }
    }, null, this);
  },
  RIGHT_CLICK: function RIGHT_CLICK(movement) {
    var viewer, polylines, mode, startNew, onDrawingEvt, nIndex, polyline, cartesian;
    return _regeneratorRuntime.async(function RIGHT_CLICK$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (this.drawing) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            viewer = this.viewer, polylines = this.polylines, mode = this.mode, startNew = this.startNew, onDrawingEvt = this.onDrawingEvt;

            if (polylines.length) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return");

          case 5:
            nIndex = polylines.length - 1;
            polyline = polylines[nIndex];

            if (!(polyline.positions.length === 0)) {
              _context5.next = 9;
              break;
            }

            return _context5.abrupt("return");

          case 9:
            cartesian = viewer.scene.pickPosition(movement.position);

            if (Cesium.defined(cartesian)) {
              _context5.next = 12;
              break;
            }

            return _context5.abrupt("return");

          case 12:
            polyline.positions.pop();

            if (mode === 0) {
              startNew();
            } else {
              this.drawing = false;
            }

            _context5.next = 16;
            return _regeneratorRuntime.awrap(this.$nextTick());

          case 16:
            onDrawingEvt(polyline, nIndex, true);

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, null, this);
  },
  startNew: function startNew() {
    var polylines = this.polylines,
        drawType = this.drawType;
    var poyline = {
      positions: []
    };
    var drawLine = drawType === 'polylineDrawing' || drawType === 'polygonDrawing';
    drawLine && _Object$assign(poyline, {
      materialLine: new Cesium.Material({
        fabric: {
          type: 'Color',
          uniforms: {
            color: makeColor(this.polylineColor)
          }
        }
      })
    });
    Cesium.defined(polylines) && polylines.push(poyline);
  },
  clear: function clear() {
    this.polylines = [];
    this.drawing = false;
  },
  onDrawingEvt: function onDrawingEvt(polyline, index) {
    var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    this.index = index;

    if (!this.depthTest) {
      this.$refs.polylineCollection.cesiumObject._opaqueRS.depthTest.enabled = false;
    }

    var listener = this.$listeners['drawEvt'];
    listener && this.$emit('drawEvt', {
      polyline: polyline,
      type: this.drawType,
      finished: flag
    });
  }
};
var mixinDraw = {
  mixins: [cmp],
  props: props,
  watch: watch,
  computed: computed,
  methods: methods,
  destroyed: function destroyed() {
    var handler = this.handler;

    if (handler) {
      handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
    }
  }
};

export default mixinDraw;
